import { formatDateShort } from '../../helpers'
import type { BillSummary } from '../../models'

function truncateText(text: string, maxChars: number): string {
  if (maxChars > 0 && text.length > maxChars) {
    const keep = Math.max(0, maxChars - 3)
    return text.slice(0, keep) + '...'
  }
  return text
}

interface BillSearchResultsProps {
  results: BillSummary[]
  onSelect: (boletin: string) => void
  containerClass?: string
  itemClass?: string
  showDate?: boolean
  truncateTitleAt?: number
}

export function BillSearchResults({
  results,
  onSelect,
  containerClass,
  itemClass,
  showDate = false,
  truncateTitleAt = 0,
}: BillSearchResultsProps) {
  const resolvedContainerClass = containerClass || 'search-results-dropdown'
  const resolvedItemClass = itemClass || 'search-result-item'

  return (
    <div className={resolvedContainerClass}>
      {results.map((bill) => {
        const title = truncateText(bill.title, truncateTitleAt)
        return (
          <button
            key={bill.boletin}
            type="button"
            className={resolvedItemClass}
            onMouseDown={(ev) => {
              if (ev.button !== 0) return
              ev.preventDefault()
              onSelect(bill.boletin)
            }}
            onClick={(ev) => {
              if (ev.detail === 0) {
                onSelect(bill.boletin)
              }
            }}
          >
            <div className="search-result-header">
              <span className="search-result-boletin">{bill.boletin}</span>
              {showDate && (
                <span className="search-result-date">{formatDateShort(bill.filing_date)}</span>
              )}
            </div>
            <div className="search-result-title">{title}</div>
          </button>
        )
      })}
    </div>
  )
}
